import { h } from "preact";
import { ProductTypeRevision } from "../api/product-api";
import { cn } from "../helpers/cn";

export function RevisionSelect({
    revisions,
    currentRevision,
    selected,
    onChange,
}: {
    revisions: ProductTypeRevision[];
    currentRevision?: ProductTypeRevision | null;
    selected: ProductTypeRevision | null;
    onChange: (revision: ProductTypeRevision | null) => void;
}) {
    return (
        <div class="border border-b-0 border-gray-600 list primary">
            {revisions!.map(v => (
                <div
                    class={cn(
                        "p-2 border-b border-b-gray-600 flex items-center cursor-pointer",
                        v === selected ? "bg-[var(--primary-color)]" : "",
                    )}
                    onClick={() => onChange(v)}
                >
                    <div style="font-size: 16px;">{v.name}</div>
                    <div style="flex: 1 1;" />
                    <div>{v.changelog}</div>
                    {v.id === currentRevision?.id ? (
                        <div class="chip secondary" style="margin-left: 10px">
                            Bieżąca rewizja
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
}
